import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Umbrella({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Umbrella</title>
      <path
        d="M7.5 18.66C7.5 19.9523 8.50736 21 9.75 21C10.9926 21 12 19.9523 12 18.66V11.1M12 11.1C10.5508 11.1 8.4 12 8.4 12C8.4 12 7.14916 11.1 5.7 11.1C4.25084 11.1 3 12 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 12 19.7492 11.1 18.3 11.1C16.8508 11.1 15.6 12 15.6 12C15.6 12 13.4492 11.1 12 11.1Z"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
